<template>
<!-- eslint-disable-next-line vue/valid-v-bind-sync-->
<el-dialog title="Lobby time expired" :visible.sync="mainRoomTimeOut && currentRoom.parent ? true : false" width="25%" center>
    <div class="room-join-message">Do you want to rejoin the lobby?</div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">Cancel</el-button>
        <el-button type="primary" @click="joinRoom">Confirm</el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";
import { playAudio } from "../../utils";

export default {
    name: "JoinRoomPrompt",

    methods: {
        joinRoom: function () {
            this.$store.commit('rooms/timeOut', false);
            if (this.currentRoom.parent) {
                this.joinToRoom(this.roomToJoin);
            }
        },
        cancelForm: function () {
            this.$store.commit('rooms/timeOut', false);
        },
    },
    watch: {
        mainRoomTimeOut(timeOut){
            if(timeOut){
                playAudio()
            }
        }
    },
    computed: {
        ...mapState({
            mainRoomTimeOut: state => state.rooms.mainRoomTimeOut,
            roomToJoin: state => state.rooms.mainRoom,
            currentRoom: state => state.rooms.currentRoom
        }),
        ...mapGetters('rooms', {
            joinToRoom: 'joinRoom'
        })
    }
}
</script>

<style scoped>
.room-join-message {
    text-align: center;
}

@media (max-width: 767px) {
    >>>.el-dialog {
        width: 100% !important;
        height: calc(100% - 56px);
        margin: 56px 0 0 0 !important;
        background: #2A2A3D;
    }
}

@media (hover: none) {
    >>>.el-dialog {
        width: 100% !important;
        height: calc(100% - 56px);
        margin: 56px 0 0 0 !important;
        background: #2A2A3D;
    }
}

</style>
